<template>
  <td>
    <div class="time" v-for="(item, index) in timeList" :key="index">
      <TimeInput v-model="item.startTime" @change="change($event, index, 'startTime')" :length="25" :limit="24" small />
      〜
      <TimeInput v-model="item.endTime" @change="change($event, index, 'endTime')" :length="25" :limit="24" small />
      <CheckBox v-model="item.forwarding" @change="updateTime()">店舗への転送</CheckBox>
      <Button class="icon" small fit :disabled="timeList.length === 1 ? 'disabled' : null" @click="deleteTime(index)">
        <DeleteIcon />
      </Button>
      <Button
        v-if="timeList.length === index + 1"
        class="icon"
        small
        fit
        :disabled="timeList.length === 5 || !(item.startTime && item.endTime) ? 'disabled' : null"
        @click="insertTime()"
      >
        <AddIcon />
      </Button>
    </div>
  </td>
</template>

<script>
import Button from '@/components/atoms/Button'
import CheckBox from '@/components/atoms/CheckBox'
import TimeInput from '@/components/molecules/TimeInput'
import DeleteIcon from '@/components/icons/delete'
import AddIcon from '@/components/icons/add'

export default {
  name: 'IvrTimeInput',
  components: {
    Button,
    CheckBox,
    TimeInput,
    DeleteIcon,
    AddIcon,
  },
  props: {
    /** 時間設定リスト */
    data: Array,
  },
  computed: {
    timeList() {
      return this.data
    },
  },
  methods: {
    change(time, index, zone) {
      this.timeList[index][zone] = time
      if (!time) {
        this.timeList[index].startTime = time
        this.timeList[index].endTime = time
      }
      if (zone === 'startTime' && time > this.timeList[index].endTime) this.timeList[index].endTime = time
      if (zone === 'endTime' && this.timeList[index].startTime > time) this.timeList[index].startTime = time
      this.updateTime()
    },
    deleteTime(index) {
      this.timeList.splice(index, 1)
      this.updateTime()
    },
    insertTime() {
      this.timeList.push({ startTime: null, endTime: null, forwarding: true })
    },
    updateTime() {
      this.$emit('updateTime', this.timeList)
    },
  },
}
</script>

<style lang="postcss" scoped>
.time {
  align-items: center;
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(6, max-content);
  margin-bottom: 8px;

  &:last-child {
    margin: 0;
  }
}

.icon {
  fill: var(--brand-color);

  &:first-of-type {
    margin-left: 24px;
  }
}
</style>
